<template>
    <div class="text-center">
        <v-row>
            <v-col>
                <h2>Benutzerverwaltung</h2>
                <p><small>
                    Die hier angezeigten Familien sind nur für die Zuordnung vom Essens- und Putzplan. <br />
                    Sie entsprechen nicht den tatsächlich registrierten Familien.
                </small></p>
                <v-data-table
                    :headers="headers"
                    :items="users"
                    :loading="isSavingOid"
                    class="[ indigo  darken-2 ]"
                    dark
                    item-key="id"
                    v-sortable-data-table
                    @sorted="saveOrder"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:item.name="props">
                        <v-row>
                            <v-col>
                                <v-edit-dialog
                                    large
                                    persistent
                                    cancel-text="Abbrechen"
                                    save-text="Speichern"
                                    @open="updateName = props.item.name"
                                    @save="updateUser(props.item.name, updateName)"
                                >
                                    <div>{{ props.item.name }}</div>
                                    <template v-slot:input>
                                        <div class="mt-4 title">
                                            Namen bearbeiten
                                        </div>
                                        <v-text-field
                                            v-model="updateName"
                                            label="Name"
                                            single-line
                                            counter
                                            autofocus
                                        ></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </v-col>
                            <v-col v-if="!activateChangeOrder">
                                <div @click="showDialog(props.item.id)">
                                    <v-icon dark>
                                        mdi-delete
                                    </v-icon>
                                </div>
                                <v-dialog v-model="showDeleteDialog[props.item.id]"
                                          :retain-focus="false">
                                    <v-card>
                                        <v-card-title class="headline">
                                            Wirklich löschen?
                                        </v-card-title>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>

                                            <v-btn
                                                text
                                                @click="closeDialog(props.item.id)"
                                            >
                                                Nein
                                            </v-btn>

                                            <v-btn
                                                color="red darken-4"
                                                text
                                                @click="deleteItem(props.item.id)"
                                            >
                                                Ja
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-left">
                <v-checkbox v-model="activateChangeOrder"
                            @change="toggleSortable"
                            label="Reihenfolge ändern" />
            </v-col>
        </v-row>
        <v-dialog v-model="showAddDialog"
                  transition="dialog-bottom-transition">
            <template v-slot:activator="{ on, attrs }">
                <v-row>
                    <v-col>
                        <v-btn
                            class="mx-2"
                            fab
                            dark
                            large
                            color="cyan"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon large>
                                mdi-account-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <v-container class="white">
                <v-row>
                    <v-col
                        cols="12"
                        md="4">
                        <v-text-field label="Name" v-model="name"/>
                    </v-col>
                </v-row>
                <v-row class="text-center">
                    <v-col>
                        <v-btn
                            large
                            color="cyan"
                            dark
                            :loading="isSending"
                            @click="saveUser"
                        >
                            Eintragen
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-dialog>
    </div>
</template>

<script>
import UserService from '@/services/UserService';
import Sortable from 'sortablejs';

let sortable;

export default {
    name: 'UserManage',
    data() {
        return {
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                }
            ],
            isSending: false,
            users: [],
            name: '',
            updateName: '',
            showAddDialog: false,
            showDeleteDialog: [],
            isSavingOid: false,
            activateChangeOrder: false
        }
    },
    async created() {
        if (!this.isAdmin) {
            this.$router.push('/')
        }
        this.users = await UserService.getPlanUsers()
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin
        }
    },
    methods: {
        async saveUser() {
            this.isSending = true
            try {
                await UserService.addPlanUser(this.name)
                this.users = await UserService.getPlanUsers()
                this.showAddDialog = false
                this.name = ''
            } catch(error) {
                console.log('Error :/', error)
            }
            this.isSending = false
        },
        async updateUser(oldName, newName) {
            if (oldName === newName) {
                return false
            }
            try {
                await UserService.editPlanUser(oldName, newName)
                this.users = await UserService.getPlanUsers()
                this.updateName = ''
            } catch(error) {
                console.log('Error :/', error)
            }
        },
        async deleteItem(id) {
            this.closeDialog(id)
            try {
                await UserService.deletePlanUser(id)
                this.users = await UserService.getPlanUsers()
            } catch (error) {
                console.log(error)
            }
        },
        showDialog(id) {
            this.$set(this.showDeleteDialog, id, true)
        },
        closeDialog(id) {
            this.$set(this.showDeleteDialog, id, false)
        },
        async saveOrder(event) {
            this.isSavingOid = true
            const movedItem = this.users.splice(event.oldIndex, 1)[0]
            this.users.splice(event.newIndex, 0, movedItem)
            try {
                await UserService.changeOrderId(this.users)
                this.users = await UserService.getPlanUsers()
            } catch(error) {
                console.log('Error :/', error)
            }
            this.isSavingOid = false
        },
        toggleSortable() {
            const state = sortable.option('disabled')
            sortable.option('disabled', !state)
        }
    },
    directives: {
        sortableDataTable: {
            bind(el, binding, vnode) {
                const options = {
                    animation: 150,
                    onUpdate: function (event) {
                        vnode.child.$emit('sorted', event)
                    }
                }
                sortable = Sortable.create(el.getElementsByTagName('tbody')[0], options)
                const state = sortable.option('disabled')
                sortable.option('disabled', !state)
            }
        }
    }
}
</script>
